// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"WishlistContent_wishlist__q1UCX"};